import React from 'react';
import { NavBar } from './NavBar.js';
import { VersionBadge } from './VersionBadge.js';

export function Layout({ children }: { children: React.ReactNode }): React.ReactElement {
  return (
    <>
      <NavBar />
      <main>{children}</main>
      <VersionBadge />
    </>
  );
}
